import TextField from '@mui/material/TextField';
import type { DashboardT } from 'business/definitions';
import Loading from 'components/Loading';
import GeneralModal from 'components/SharedComponents/Modals/GeneralModal';
import DashboardList from 'modules/decision/components/DashboardList/DashboardList';
import type { ChangeEvent, ReactNode } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { filterDashboardsByTitle } from 'routes/Library/helpers';
import { useFetchActiveDashboards } from 'shared/api/getDashboardsList';
import { useSelector } from 'store/hooks';

type Props = {
    open: boolean;
    onClose: () => void;
    dashboardItemRender: (arg1: DashboardT, arg2: string) => ReactNode;
};

const DashboardsManagerModal = ({
    open,
    onClose,
    dashboardItemRender,
}: Props) => {
    const [filter, setFilter] = useState('');
    const { data: allDashboards, isLoading } = useFetchActiveDashboards();

    const filteredDashboards = filterDashboardsByTitle(
        allDashboards ?? [],
        filter,
        [],
    );

    const homeDashboardSlug = useSelector(
        (state) => state.vision.user.homeDashboardSlug,
    );

    const { t } = useTranslation();
    const onFilterChange = (e: ChangeEvent<HTMLInputElement>): void =>
        setFilter(e.target.value);

    const modalContent = isLoading ? (
        <Loading />
    ) : (
        <>
            <TextField
                value={filter}
                autoFocus
                variant="outlined"
                margin="dense"
                size="small"
                fullWidth
                label={t('home.searchDashboard')}
                onChange={onFilterChange}
            />
            <DashboardList
                dashboards={filteredDashboards}
                dashboardItemRender={(dashboard) =>
                    dashboardItemRender(dashboard, filter)
                }
                homeDashboardSlug={homeDashboardSlug}
            />
        </>
    );
    const textButton = {
        text: t('common.close'),
        onClick: onClose,
    };
    return (
        <GeneralModal
            isOpen={open}
            onClose={onClose}
            showCloseButton={false}
            shouldCloseOnBackdropClick
            textButton={textButton}
        >
            {modalContent}
        </GeneralModal>
    );
};

export default DashboardsManagerModal;
